import { useEffect } from 'react';

import { auditStore } from '@stores/auditStore';

export const useAuditView = (dictionaryName: string): void => {
  useEffect(() => {
    auditStore.createAuditData({
      moduleName: 'Calculator',
      serviceName: 'Reference_book',
      operationName: 'View_reference_book',
      message: `Справочник "${dictionaryName}"`,
    });
  }, [dictionaryName]);
};
